module.exports = __webpack_public_path__ + "html/like_4ab86247caa54544bfe9c4638b2b352d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/like.html
// module id = f86U
// module chunks = 153